<!--
 * @Date: 2020-05-19 15:29:30
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-06-01 10:16:12
 * @FilePath: /xy-pc/src/views/userCenter/myCourse/normalList.vue
--> 
<template>
  <div style="width:100%">
    <el-row :gutter="15" style="min-height:50vh" v-if="classlist.length>0">
      <el-col :span="6" v-for="(item, index) in classlist" :key="index" style="margin-bottom:15px">
        <el-card>
          <div
            class="class_Item"
            @click="$router.push({path:'/courseDetail',query:{id:item.course.id,classId:item.id}})"
          >
            <div class>
              <el-image style="height:120px;width:100%" :src="item.course.thumb_image" class="class-img"></el-image>
            </div>
            <div class="class_contant ellipsis-1">{{item.course.title}}</div>
            <div class="class_position ellipsis-1">岗位： <span v-for="(duty,idnexs) in item.course.duty" :key="idnexs">{{duty.name}}</span></div>
            <el-rate :value="item.course.score-0" disabled class="time"></el-rate>
            <!-- <div class="time">时间：{{item.course.score}}</div> -->
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div v-if="classlist.length==0">
      <el-card>
        <p style="text-align:center;margin-top:130px;margin-bottom:100px">暂无普通课程 !</p>
      </el-card>
    </div>
    <div style="margin:20px 0 40px;text-align: center;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="limit"
        layout=" sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1",
      page: 1,
      limit: 8,
      total: 0,
      classlist: []
    };
  },
  created() {
    this.getPageList();
  },
  methods: {
    getPageList() {
      this.$http({
        url: "api/v1/auth/user-courses",
        method: "get",
        params: { type: 1, page: this.page, limit: this.limit }
      }).then(res => {
        if (res.status == 200) {
          this.classlist = res.data.user_courses;
          if (res.data.total) {
            this.total = res.data.total;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**每页数 */
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getPageList();
    },
    /**当前页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getPageList();
    }
  }
};
</script>

<style lang="less" scoped>
.class-img:hover {
  transform: scale(1.1);
}
.class-img {
  cursor: pointer;
  transition: all 0.6s;
}

.head {
  background: #000;
  height: 72px;
}
.head .head_left {
  margin-left: 251px;
  overflow: hidden;
}
.head .head_left ul li {
  float: left;
  line-height: 72px;
  width: 104px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
}
.head .head_left ul li:first-child {
  width: 60px;
}
.head .head_input {
  width: 248px;
  height: 31px;
  left: 1397px;
  top: 21px;
  position: absolute;
  border: none;
  border-bottom: 1px solid rgba(153, 153, 153, 1);
  background: transparent;
  color: rgba(229, 229, 229, 1);
}
.head_search {
  width: 24px;
  height: 24px;
  left: 1621px;
  top: 21px;
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  position: absolute;
}
.student_portrait {
  width: 32px;
  height: 32px;
  left: 1798px;
  top: 20px;
  border-radius: 16px;
  position: absolute;
}
.student_messages {
  width: 16px;
  height: 16px;
  left: 1821px;
  top: 24px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 0, 0, 1);
  border-radius: 8px;
  font-size: 10px;
  line-height: 150%;
  text-align: center;
  font-weight: bold;
  position: absolute;
}
.portrait {
  background: url("../../../assets/image/student_bg.png");
  height: 148px;
  background-size: cover;
  position: relative;
}
.portrait img {
  width: 140px;
  height: 140px;
  left: 384px;
  top: 30px;
  border-radius: 70px;
  border: rgba(255, 255, 255, 1) solid 4px;
  box-shadow: 0px 8px 8px 0px rgba(153, 153, 153, 0.2);
  position: relative;
}
.portrait_name {
  width: 100px;
  height: 28px;
  left: 554px;
  top: 48px;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  line-height: 150%;
  text-align: left;
  font-weight: bold;
  position: absolute;
}
.portrait_phone {
  width: 117px;
  height: 28px;
  left: 554px;
  top: 90px;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: left;
  position: absolute;
}
.Personal {
  background: #fff;
}
.Personal_left {
  width: 140px;
  height: 315px;
  left: 415px;
  top: 70px;
  position: relative;
}
.contant {
  width: 960px;
  height: 414px;
  left: 615px;
  top: -240px;
  position: relative;
}
.Personal_left li {
  width: 107px;
  height: 27px;
  color: rgba(120, 125, 130, 1);
  font-size: 16px;
  margin-top: 13px;
}
.Personal_left li img {
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: rgba(120, 125, 130, 1);
  position: relative;
  color: #787d82;
  top: 4px;
}
.Personal_left .active {
  width: 140px;
  height: 41px;
  color: #fff;
  background-color: rgba(42, 130, 228, 1);
  border-radius: 12px;
  line-height: 41px;
  text-align: center;
  position: relative;
  left: -26px;
}
.Personal_right {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  position: relative;
}
.Personal_right .Personal_title {
  height: 28px;
  top: -29px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  line-height: 150%;
  width: 74px;
}
.Personal_hen {
  width: 960px;
  height: 1px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(153, 153, 153, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  position: relative;
  top: -25px;
}
.contant_list {
  margin-top: 15px;
  height: 85px;
}
.Personal_right .blues {
  color: rgba(42, 130, 228, 1);
}
.Personal_right .blue {
  width: 74px;
  height: 3px;
  left: 0px;
  top: -23px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(42, 130, 228, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  position: relative;
}
.study_class {
  width: 104px;
  height: 32px;

  color: rgba(255, 255, 255, 1);
  background-color: rgba(42, 130, 228, 1);
  border-radius: 20px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
}
.histroy_class {
  width: 104px;
  height: 32px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(145, 153, 161, 1);
  border-radius: 17px;
  font-size: 16px;
  line-height: 30px;
  position: relative;
  top: -32px;
  left: 150px;
  text-align: center;
}

.class_Item {
  .class_contant {
    width: 216px;
    // height: 46px;
    padding: 4px 0;
    color: #444;
    font-size: 14px;
    line-height: 150%;
    text-align: left;
  }
  .class_position {
    width: 197px;
    height: 32px;
    color: #808080;
    font-size: 13px;
    line-height: 150%;
    text-align: left;
  }
  .class_time {
    width: 176px;
    height: 32px;
    color: rgba(80, 80, 80, 1);
    font-size: 16px;
    line-height: 150%;
    text-align: left;
  }
}
.order_list:nth-child(4) {
  margin-right: 0;
}
.order_list {
  width: 216px;
  border-radius: 10px;
  float: left;
  margin-right: 52px;
  margin-top: 10px;
  img {
    width: 216px;
    height: 121px;
  }
  .class_contant {
    width: 216px;
    height: 46px;
    color: rgba(7, 17, 27, 1);
    font-size: 16px;
    line-height: 150%;
    text-align: left;
  }
  .class_position {
    width: 197px;
    height: 32px;
    color: rgba(80, 80, 80, 1);
    font-size: 16px;
    line-height: 150%;
    text-align: left;
  }
  .time {
    width: 59px;
    height: 21px;
    color: rgba(245, 123, 1, 1) !important;
    background-color: rgba(255, 141, 26, 0.08571428571428569);
    border-radius: 2px;
    font-size: 13px;
    line-height: 150%;
    float: right;
    text-align: center;
    margin-top: 8px;
  }
}
</style>